import React from 'react';

const Footer = ({ isLandscape, isMobile }) => {
  const currentYear = new Date().getFullYear();

  // No mostrar footer en móvil
  if (isMobile) return null;

  return (
    <footer className="w-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-slate-100 py-6 md:py-8 border-t border-slate-700 relative m-0 p-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Brand Section */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold text-white whitespace-nowrap">Terapia Online TDAH - Clínica Milos</h3>
            <p className="text-slate-300 text-sm">
              Psicología profesional y terapia online especializada en tu bienestar emocional.
            </p>
            <div className="flex gap-4 mt-2">
              <a href="https://www.facebook.com/p/Centro-Milos-100055228726620/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-blue-400 transition-colors" aria-label="Facebook">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
              <a href="https://www.instagram.com/clinicamilos/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-blue-400 transition-colors" aria-label="Instagram">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
            </div>
          </div>

          {/* Information */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Información</h4>
            <ul className="space-y-2">
              <li><a href="/politica-privacidad" className="text-slate-300 hover:text-blue-400 transition-colors">Política de Privacidad</a></li>
              <li><a href="/condiciones-servicio" className="text-slate-300 hover:text-blue-400 transition-colors">Condiciones del Servicio</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contacto</h4>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              <div className="text-slate-300">
                <span className="text-slate-400 block mb-1">Badajoz</span>
                C/San Juán de Dios, Nº5<br />(06003) Badajoz
                <br /><br />
                <a href="tel:+34664172313" className="hover:text-blue-400 transition-colors">664 172 313</a>
              </div>
              <div className="text-slate-300">
                <span className="text-slate-400 block mb-1">Don Benito</span>
                C/José Mª Álvarez, 2. 1º B<br />06400 Don Benito (Badajoz)
                <br /><br />
                <a href="tel:+34637739659" className="hover:text-blue-400 transition-colors">637 739 659</a>
              </div>
              <div className="col-span-2 text-slate-300">
                <span className="text-slate-400">Email: </span>
                <a href="mailto:info@centromilos.com" className="hover:text-blue-400 transition-colors">
                  info@centromilos.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 pt-8">
          {/* Bottom Footer */}
          <div className="flex justify-center items-center">
            <p className="text-slate-400 text-sm">
              © {currentYear} Clínica Milos. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
